module.exports = __webpack_public_path__ + "media/volvo/assets/images/volvo_v70@2x-70184f6a2995a87027cade52b54e16df.png";